/* globals window, */

export default class Utils {
    static onNextFrame(callback) {
        setTimeout(() => window.requestAnimationFrame(callback), 0);
    }
}
